import { CardShopStruct } from "../structs/CardShopStruct";

export class CardShopRepository {

    static getAll() {
        return JSON.parse(localStorage.getItem("card_shop")) || [];
    }

    static getItem(id) {
        const list = this.getAll();
        if (!list.length) return false;

        const find = list.find(item => item?.product?.id === id);
        return find || false;
    }

    static deleteAll() {
        return localStorage.removeItem("card_shop");
    }

    static addCardShop(productItem) {
        if (!productItem) return;

        let list = this.getAll();
        let check = false;

        list.forEach(item => {
            if (item?.product?.id === productItem.id) {
                // جمع کردن تعداد با حداکثر ۳ رقم اعشار
                item.count = parseFloat((parseFloat(item.count || 0) + 1).toFixed(3));
                check = true;
            }
        });

        if (!check) {
            let cardShopStruct = new CardShopStruct();
            cardShopStruct.product = productItem;
            cardShopStruct.count = parseFloat((1).toFixed(3)); // شروع با ۱ و ۳ رقم اعشار
            list.push(cardShopStruct);
        }

        localStorage.setItem("card_shop", JSON.stringify(list));
    }

    static decreaseCardShop(productItem) {
        if (!productItem) return;

        let list = this.getAll();

        list.forEach((item, i) => {
            if (item?.product?.id === productItem.id) {
                if (item.count > 1) {
                    item.count = parseFloat((item.count - 1).toFixed(3));
                } else {
                    list.splice(i, 1);
                }
            }
        });

        localStorage.setItem("card_shop", JSON.stringify(list));
    }

    static updateCount(productItem, newCount) {
        if (!productItem) return;

        let list = this.getAll();
        const index = list.findIndex(item => item?.product?.id === productItem.id);

        if (index !== -1) {
            if (newCount <= 0) {
                list.splice(index, 1);
            } else {
                list[index].count = parseFloat(newCount.toFixed(3));
            }
        } else if (newCount > 0) {
            let cardShopStruct = new CardShopStruct();
            cardShopStruct.product = productItem;
            cardShopStruct.count = parseFloat(newCount.toFixed(3));
            list.push(cardShopStruct);
        }

        localStorage.setItem("card_shop", JSON.stringify(list));
    }

    static removeItem(id) {
        let list = this.getAll();
        list = list.filter(item => item?.product?.id !== id);
        localStorage.setItem("card_shop", JSON.stringify(list));
    }
}
